export function shouldShowPaneMoreOptions({ hidePaneMoreOptions = false, isConstrained = false } = {}) {
    return !hidePaneMoreOptions && !isConstrained;
}
